
import Vue from 'vue';

export default Vue.extend({
  name: 'ChefBookFaq',
  data() {
    return {
      faqs: [
        {
          'title': 'Wanneer hoor ik of een cateraar op mijn gekozen datum kan?',
          'content': 'De meeste cateraars reageren binnen 3 uur. In sommige gevallen hebben ze wat meer tijd nodig, bijvoorbeeld als ze personeel mee zullen nemen.',
        }, {
          'title': 'Kan ik mijn reservering nog wijzigen?',
          'content': 'Je kan tot 7 dagen voor het diner altijd nog dingen wijzigen, daarna in overleg met je cateraar. Mochten er dingen wijzigen, laat ons dit dan altijd weten zodat we alles goed voor jou kunnen regelen en verrekenen. Bijvoorbeeld als het aantal personen verandert, het diner verplaatst moet worden naar een andere datum, of als je extra’s bij wilt boeken.',
        }, {
          'title': 'Kan ik zelf een menu samenstellen?',
          'content': 'Meestal werken cateraars met een selectie gerechten waar zij heel goed in zijn. Als je zelf een idee hebt wat je op het menu wilt zien, geef dit dan duidelijk aan in de reservering.',
        }, {
          'title': 'Is een reservering vrijblijvend?',
          'content': 'Op het moment dat je reserveert, zit je nog helemaal nergens aan vast. We gaan eerst dubbelchecken of de cateraar beschikbaar is op jouw gekozen datum. Je krijgt dan een bericht van ons dat je reservering klaar staat om te bevestigen.',
        }, {
          'title': 'Zijn mijn persoonsgegevens veilig?',
          'content': 'Privacy en data veiligheid zijn erg belangrijk voor ons. We hebben onze systemen zodanig ingericht om die veiligheid te borgen en gebruiken jouw data enkel om onze dienstverlening uit te voeren. Lees meer hierover in onze Privacyverklaring.',
        }, {
          'title': 'Kan er rekening gehouden worden met allergieën?',
          'content': 'Wij werken uitsluitend met professionele cateraars die met jouw allergie rekening kunnen houden. Geef bij de reservering duidelijk aan om welke allergieën het gaat.',
        }
      ]
    }
  }
})
